import React, { useEffect, useState } from 'react'
import { useQuery } from '@apollo/client'

import { analytics } from '~/analytics'
import { Carousel } from '~/components'
import { bannersQuery } from '~/gql/queries'
import { useVendor } from '~/hooks'
import { analyticsCreativeSlot } from '~/utils/constants'

import Banner from '../banner'

const DEFAULT_BANNER_INTERVAL = 3000

const Banners = () => {
  const { data } = useQuery(bannersQuery)

  const dataSource = data?.vendor?.banners

  const vendor = useVendor()

  const bannersIntervalInMs = vendor?.settings?.theme?.bannersIntervalInMs

  const [isEventSent, setIsEventSent] = useState(false)

  const onBannerRender = () => {
    analytics.viewPromotion(analyticsCreativeSlot.MAIN_BANNERS)

    setIsEventSent(true)
  }

  useEffect(() => {
    onBannerRender()
  }, [])

  return (
    <Carousel
      dataSource={dataSource}
      autoplayInterval={bannersIntervalInMs ?? DEFAULT_BANNER_INTERVAL}
      afterSlide={() => setIsEventSent(false)}
      renderer={banner => {
        return <Banner key={banner.id} onRender={onBannerRender} isEventSent={isEventSent} {...banner} />
      }}
    />
  )
}

export default Banners
